<template>
  <div class="container">
    <van-nav-bar :title="this.lottery.name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="record">
      <div class="period">
        <van-image class="cover" :src="this.lottery.ico">
          <template v-slot:loading>
            <van-loading type="spinner"/>
          </template>
        </van-image>
        <span class="period-number">{{ this.lottery.next_expect }}</span>
        <div class="next-number">
          <van-count-down :time="time" @finish="check()"/>
        </div>
      </div>
      <div class="linear-gradient"
           style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
      <div class="recent">
        <div class="kuaisan-ball left">
          <span class="res-des middle">{{ this.size }}</span>
          <span class="res-des middle">{{ this.double }}</span>
        </div>
        <i class="van-icon van-icon-arrow-down down" @click="active = !active"></i>
      </div>

    </div>
    <div class="history_popup"></div>
    <div class="wrapper">
      <div class="options-bar">
        <div class="game">
          <div class="linear-gradient"
               style="background: linear-gradient(to right, rgba(126, 86, 120, 0), rgb(230, 195, 161), rgba(126, 86, 120, 0));"></div>
          <div class="sumValueTwoSides">
            <div class="rectangle large" :class="{active:choose[v.type]}" v-for="(v,key) in lottery_peilv_list"
                 :key="key" @click="choosePlay(v.type,v.name);">
              <div class="wrapper">
                <div class="content">
                  <p class="name-text large">{{ names(v.name) }}</p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <div class="bottom-bar">
        <div class="bar">
          <div class="left">
            <div class="item" @click="shopping ? shopping = false : shopping = true ">
              <van-icon name="cart-o" class="jixuanico"/>
              {{ $t("choice") }}
            </div>
            <div class="line"></div>
          </div>
          <div class="mid">
            <span class="text">{{ $t("lottery.money") }}</span>
            <div>
                <span class="text num">{{ this.userInfo.money * 1 }}</span>
                <span class="text">{{ $store.getters.getBaseInfo.currency }}</span>
            </div>
          </div>
          <div class="right" @click="jiesuan()">
            {{ $t("lottery.submit") }}
          </div>
        </div>
        <div class="wrapper" :class="{active:shopping}">
          <div class="item">
            <span class="label">{{ $t("lottery.selection") }}：</span>
            <div class="bet-number">{{ this.shopchoose }}</div>
            <van-icon name="arrow-down" :class="{ up: !shopping,down:shopping }"
                      @click="shopping ? shopping = false : shopping = true"/>
          </div>
          <div class="item">
            <span class="label">{{ $t("lottery.perNote") }}：</span>
            <div class="amount-wrapper">
              <van-field v-model="money" type="digit" :placeholder="$t('lottery.inputMoney')"/>
              <span class="label"
                    style="width: 40PX;margin-left: 5px"> {{ $store.getters.getBaseInfo.currency }}</span>
            </div>
          </div>
          <div class="item">
            <div class="part">
              <span>{{ $t("lottery.total") }}</span>
              <span class="number">{{ this.formData.length }}</span>
              <span>{{ $t("lottery.note") }}</span>
            </div>
            <div class="part">
              <span>
                {{ $t("lottery.statistics") }}
              </span>
              <span class="number">{{ this.formData.length * this.money }}</span>
              <span>{{ $store.getters.getBaseInfo.currency }}</span>
            </div>
          </div>
          <!--          <div class="jifenItemBox">
                      <div v-for="(vo,keys) in betting_amount" :key="keys" :class="money==vo?'active':''" @click="moneyFun(vo)">
                        {{ formatNumber(vo) }}
                      </div>
                    </div>-->
        </div>
      </div>


      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('msg.下拉即可刷新')"
                          :loosing-text="$t('msg.释放即可刷新')" :loading-text="$t('msg.加载中')">
          <div class="wrapper">
            <div class="item">
              <div class="left font-weight">{{ $t("lottery.issue") }}</div>
              <div class="right font-weight">{{ $t("lottery.num") }}</div>
            </div>
            <div class="item" v-for="(v,key) in lottery_list" :key="key">
              <div class="left font-weight">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span
                      class="ressquareBox">{{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 ? $t("大") : $t("小")
                    }}</span>
                  <span class="ressquareBox">{{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? $t("双") : $t("单")
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>


    <van-popup v-model="jiesuanpage" get-container="body">
      <div class="confirm-order-modal">
        <div class="head van-hairline--bottom">
          <p class="text">{{ $t("lottery.task") }}</p>
        </div>

        <ui class="list">
          <li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
            <div class="main">
              <p class="bet-name">{{ names(v.name) }}</p>
              <p class="detail-text">1{{ $t("lottery.note") }}X{{ money }} {{ $store.getters.getBaseInfo.currency }} = {{ money }} {{ $store.getters.getBaseInfo.currency }}</p>
            </div>
            <van-icon @click="clearChooes(v.type)" name="close"/>
          </li>
        </ui>
        <div class="sub-bar">
          <van-button class="item cancel-btn" type="default" @click="allClear()">{{
              $t("lottery.empty")
            }}
          </van-button>
          <van-button class="item sub-btn" type="default" @click="doSub">{{ $t("lottery.verify") }}</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
//var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      choose: {
        "大": false,
        "小": false,
        "单": false,
        "双": false,
      },
      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: {},
      lottery_list: {},
      active: false,
      userInfo: {},
      lottery: {},
      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",
      sum: 0,
      size: "",
      double: "",
      time: 0,
      shopchoose: this.$t("lottery.unselected"),
      gameitem: "",
      formData: [],
      betting_amount: [],
      money: "",
      currency: "",
    };
  },
  methods: {

    formatNumber(num) {
      if (num >= 1000 && num < 10000) {
        return (num / 1000).toFixed(0) + 'K';
      } else if (num >= 10000) {
        return (num / 10000).toFixed(0) + 'W';
      } else {
        return num.toString();
      }
    },
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        this.betting_amount = res.data.betting_amount;
      })
    },
    back() {
      return window.history.back();
    },
    moneyFun(money) {
      this.money = money
    },
    names(name) {
      return this.$t(name);
      /*if (name == "大") {
        return this.$t("大");
      } else if (name == "小") {
        return this.$t("小");
      } else if (name == "单") {
        return this.$t("单");
      } else if (name == "双") {
        return this.$t("双");
      }
      return name;*/
    },
    doSub() {
      if (this.money == "0") {
        this.$toast(this.$t("msg.金额错误！"));
        return false;
      }
      if (this.formData.length == 0) {
        this.$toast(this.$t("msg.请选号！"));
        return false;
      } else if (this.money == "") {
        this.$toast(this.$t("msg.请填写金额!"));
        return false;
      } else {
        if (this.userInfo.money - (this.money * this.formData.length) < 0) {
          this.$toast(this.$t("msg.余额不足，请联系客服充值！"));
          return false;
        } else {
          this.$http({
            method: 'get',
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res => {
            if (res.code === 200) {
              this.$toast(this.$t("msg." + res.msg));
              this.allClear();
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(this.$t("msg." + res.msg));
            }
          })
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("lottery.unselected");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan() {
      if (this.formData.length == 0) {
        this.$toast(this.$t("msg.请选号！"));
        return false;
      } else if (this.money == "") {
        this.$toast(this.$t("msg.请填写金额!"));
        return false;
      } else if (this.money == 0) {
        this.$toast(this.$t("msg.金额错误！"));
        return false;
      } else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]['type']) {
          this.formData.splice(i, 1)
          this.choose[type] = false;
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.names(this.formData[j]['name']);
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.names(this.formData[j]['name']);
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("lottery.unselected");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]['type']) {
            this.formData.splice(i, 1)
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({'name': name, 'type': type})
        this.choose[type] = true;
      }
      if (this.formData.length === 1) {
        this.shopping = true;
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.names(this.formData[j]['name']);
            this.gameitem = this.formData[j]['type'];
          } else {
            this.shopchoose += "," + this.names(this.formData[j]['name']);
            this.gameitem += "," + this.formData[j]['type'];
          }
        }
      } else {
        this.shopchoose = this.$t("lottery.unselected");
        this.gameitem = "";
        this.shopping = false;
      }

    },
    check() {
      if (!localStorage.getItem('token')) {
        this.$router.push({path: '/Login'})
      } else {
        /*time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0)
        }, 300)*/

        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("msg.刷新成功！"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          //this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv() {
      this.$http({
        method: 'get',
        data: {id: this.$route.query.id},
        url: 'lottery_get_peilv'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_one_list'
      }).then(res => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo() {
      this.$http({
        method: 'get',
        data: {key: this.$route.query.key},
        url: 'lottery_get_info'
      }).then(res => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("lottery.kefu"));
            this.$router.push({path: '/Home'})
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("lottery.drawLottery") + this.lottery.now_expect);
          }
          this.shanzi_1 = res.data.opencode[0];
          this.shanzi_2 = res.data.opencode[1];
          this.shanzi_3 = res.data.opencode[2];
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if (this.sum >= 11 && this.sum <= 18) {
            this.size = this.$t("大");
          } else if (this.sum >= 3 && this.sum <= 10) {
            this.size = this.$t("小");
          }
          if (this.sum % 2 === 0) {
            this.double = this.$t("双");
          } else {
            this.double = this.$t("单");
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
      this.getLotteryInfo();
      this.getLotteryList();
      //this.getBaseInfo();
      /*this.currency = this.$store.getters.getBaseInfo.currency;
      console.log(this.currency);*/
    }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container{
  height: 100vh;
}
.kuaisan-ball .res-des {
  font-weight: 700;
  text-align: center;
  color: #c24491;
}

.rectangle .wrapper {
  flex: 1;
  background: #f2f2f5
}

.rectangle.active .wrapper {
  background-color: #c24491 !important;
}
.wrapper .item .kuaisan-ball {
  justify-content: center;
}
.ressquareBox{
  margin-left: 10px;
}
</style>
